"use client";

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useCompanyId } from '@/lib/company-id-context';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const { tenantId, loading } = useCompanyId();

  useEffect(() => {
    if (loading) return;
    if (!tenantId) {
      const next = pathname ? `?next=${encodeURIComponent(pathname)}` : '';
      router.replace(`/login${next}`);
    }
  }, [loading, pathname, router, tenantId]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <p className="text-sm text-gray-700">Loading…</p>
      </div>
    );
  }

  if (!tenantId) {
    return null;
  }

  return children;
}

